import Dexie, { type EntityTable } from 'dexie';

interface UserEntry {
  id: string;
  data: any;
}

interface RequisitionEntry {
  id?: number;
  requisition_id: any;
}

interface ProductEntry {
  id?: number;
  requisition_id: number,
  data: any;
  qty: any;
  variant: any;
  remark: any;
  id_variant: any;
  id_product: any;
  rob:number;
  est_rob:number;
}

interface AccessPermissionEntry {
  id: string;
  data: string[];
}

const db = new Dexie('SsmsDatabase') as Dexie & {
  storage: EntityTable<UserEntry, 'id'>,
  requisition: EntityTable<RequisitionEntry>,
  product: EntityTable<ProductEntry>,
  permission: EntityTable<AccessPermissionEntry, 'id'>,

};

db.version(1).stores({
  storage: '&id',
  requisition: '++id, requisition_id',
  product: '++id, id_product, data, qty, id_variant, variant, rob, requisition_id, remark, est_rob',
  permission: '&id',
});

export type { UserEntry, ProductEntry };
export { db };
